/**
 * Created by 新思 on 2017/3/6.
 */
export default {
  change_navigationTitle (state,data){
    state.navigationTitle = data;
  },
  change_navigationShow (state,data){
    state.navigationShow = data;
  },
  change_nowClassify (state,data){
    state.nowClassify = data;
  },
  change_messageNumber (state,data){
    state.messageNumber = data;
  },
  change_problem (state,data){
    state.problem = data;
  },
  change_city (state,data){
    state.city = data;
  },
  change_payData (state,data){
    state.payData = data;
  },
  change_ingot (state,data){
    state.ingot = data;
  },
  
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js